import api from "../../utils/axios";
import { DRIVER_SALARY_PAYOUT_ENDPOINTS } from "./endpoints";
import {
	DriverSalaryPayoutRequest,
	DriverSalaryPayoutResult,
	PayableDriverBalance,
} from "./types";

/** Drivers with a positive salary balance, sorted by name. Read-only. */
export const getPayableDriverBalances = async (): Promise<
	PayableDriverBalance[]
> => {
	const response = await api.get<PayableDriverBalance[]>(
		DRIVER_SALARY_PAYOUT_ENDPOINTS.payableBalances
	);
	return response.data;
};

/**
 * Pays each driver their balance as of now. A 409 means another payout is still running; the
 * axios interceptor already toasts the API message, so callers should not toast errors again.
 */
export const payDriverBalances = async (
	body: DriverSalaryPayoutRequest
): Promise<DriverSalaryPayoutResult> => {
	const response = await api.post<DriverSalaryPayoutResult>(
		DRIVER_SALARY_PAYOUT_ENDPOINTS.pay,
		body
	);
	return response.data;
};
